import { cn } from "~/lib/utils";

/** Small uppercase section label used across Display popover panes. */
export const PLANNING_DISPLAY_SECTION_LABEL =
  "mb-1.5 text-[11px] font-medium uppercase tracking-[0.08em] text-muted-foreground";

/** Dense selectable row used by group-by, views, and filter lists. */
const PLANNING_DISPLAY_ROW =
  "flex min-h-touch w-full min-w-0 items-center gap-2 rounded-lg px-2 text-left text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:h-7 md:min-h-0 md:rounded-md md:text-[13px]";

export function planningDisplayRowClass(opts: {
  readonly selected?: boolean;
  readonly className?: string;
}): string {
  return cn(
    PLANNING_DISPLAY_ROW,
    opts.selected
      ? "bg-muted/55 text-foreground"
      : "text-muted-foreground hover:bg-muted/35 hover:text-foreground",
    opts.className,
  );
}
